import { Grid, Typography } from "@mui/material";
import React from "react";
import StackedHorizontalBarChart from "src/sections/@dashboard/app/StackedHorizontalBarChart";
import { getDuplicateStats } from "src/services/declutter.service";

export default class UniqueVsDuplicateComparison extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            by: 'size',
            is_percentage: false,
            total_files_count: 0,
            total_files_size: 0,
            total_duplicates_count: 0,
            total_duplicates_size: 0,
            delete_success_count: 0,
            delete_success_size: 0,
            by_size: [],
            by_size_percentage: [],
            by_count: [],
            by_count_percentage: [],
            energy_impact_per_gb_per_year_by_size: []
        };

    }

    componentDidMount() {
        this.setDuplicateStats();
    }

    async setDuplicateStats() {
    
        let duplicate_stats = await getDuplicateStats();
        if (duplicate_stats.error) {
            console.error(duplicate_stats.error);
            return;
        }
        duplicate_stats = duplicate_stats.duplicate_stats;

        let stats = duplicate_stats.stats || {};
        let total_duplicates_count = duplicate_stats.total_duplicates_count || 0;
        let total_duplicates_size = duplicate_stats.total_duplicates_size || 0;
        let total_files_count = duplicate_stats.total_files_count || 0;
        let total_files_size = duplicate_stats.total_files_size || 0;
        let delete_success_count = duplicate_stats.delete_success_count || 0;
        let delete_success_size = duplicate_stats.delete_success_size || 0;

        this.setState({
            stats,
            total_duplicates_count,
            total_duplicates_size,
            total_files_count,
            total_files_size,
            delete_success_count,
            delete_success_size
        });
        let by_size = [
            {
                name: 'Unique',
                data: [total_files_size - total_duplicates_size],
                color: '#94cd81',
                stack: 'Size',
                label: 'Unique'
            },
            {
                name: 'Duplicate',
                data: [total_duplicates_size],
                color: '#f05023',
                stack: 'Size',
                label: 'Duplicate'
            },
            {
                name: 'Deleted',
                data: [delete_success_size],
                color: '#808080',
                stack: 'Size',
                label: 'Deleted'
            }
        ];
        let by_size_percentage = [
            {
                name: 'Unique',
                data: [total_files_size > 0 ? (((total_files_size - total_duplicates_size) / total_files_size) * 100).toFixed(2) : 0],
                color: '#94cd81',
                stack: 'Size',
                label: 'Unique'
            },
            {
                name: 'Duplicate',
                data: [total_files_size > 0 ? ((total_duplicates_size / total_files_size) * 100).toFixed(2) : 0],
                color: '#f05023',
                stack: 'Size',
                label: 'Duplicate'
            },
            {
                name: 'Deleted',
                data: [total_files_size > 0 ? ((delete_success_size / total_files_size) * 100).toFixed(2) : 0],
                color: '#808080',
                stack: 'Size',
                label: 'Deleted'
            }
        ];
        let by_count = [
            {
                name: 'Unique',
                data: [total_files_count - total_duplicates_count],
                color: '#94cd81',
                stack: 'Count',
                label: 'Unique'
            },
            {
                name: 'Duplicate',
                data: [total_duplicates_count],
                color: '#f05023',
                stack: 'Count',
                label: 'Duplicate'
            },
            {
                name: 'Deleted',
                data: [delete_success_count],
                color: '#808080',
                stack: 'Count',
                label: 'Deleted'
            }
        ];
        let by_count_percentage = [
            {
                name: 'Unique',
                data: [total_files_count > 0 ? (((total_files_count - total_duplicates_count) / total_files_count) * 100).toFixed(2) : 0],
                color: '#94cd81',
                stack: 'Count',
                label: 'Unique'
            },
            {
                name: 'Duplicate',
                data: [total_files_count > 0 ? ((total_duplicates_count / total_files_count) * 100).toFixed(2) : 0],
                color: '#f05023',
                stack: 'Count',
                label: 'Duplicate'
            },
            {
                name: 'Deleted',
                data: [total_files_count > 0 ? ((delete_success_count / total_files_count) * 100).toFixed(2) : 0],
                color: '#808080',
                stack: 'Count',
                label: 'Deleted'
            }
        ];

        let energy_impact_per_gb_per_year_by_size = [
            {
                name: 'Unique',
                data: [((total_files_size - total_duplicates_size) * 0.005 / (1024 * 1024 * 1024))],
                color: '#94cd81',
                stack: 'Energy Impact',
                label: 'Unique'
            },
            {
                name: 'Duplicate',
                data: [(total_duplicates_size * 0.005 / (1024 * 1024 * 1024))],
                color: '#f05023',
                stack: 'Energy Impact',
                label: 'Duplicate'
            }
        ]

        this.setState({
            by_size,
            by_size_percentage,
            by_count,
            by_count_percentage,
            energy_impact_per_gb_per_year_by_size
        });
    }

    render() {
        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h5" fontWeight={400} color={'gray'}>
                        Unique files vs duplicates
                    </Typography>
                </Grid>

                <Grid item xs={12}>
                    <StackedHorizontalBarChart
                        series={this.props.is_percentage ? (this.props.by === 'size' ? this.state.by_size_percentage : this.state.by_count_percentage) : (this.props.by === 'size' ? this.state.by_size : this.state.by_count)}
                        labels={[this.props.by === 'size' ? 'Size' : 'Count']}
                        value_type={this.props.is_percentage ? 'percentage' : (this.props.by === 'size' ? 'size' : 'count')}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Typography variant="body2" color={'gray'}>
                        Fewer duplicates means more unique files, which can lead to better organization and easier file management. They reduce version confusions and lower the risk of working on outdated files.
                    </Typography>
                </Grid>
            </Grid>
        );
    }
}
